import { FormGroup } from "@mui/material";
import {
  AVAILABLE_TILES,
  getTilePreviewUrl,
  Tiles,
  TILE_CONFIG,
} from "../../../global/constants/tiles";
import { useLayers } from "../../../context/LayersContext";

export default function MapTilesModal() {
  const { tile, addNewTile } = useLayers();

  function MapTileImage({
    icon,
    tileSelected,
    tileName,
    onClick,
  }: {
    icon: string;
    tileSelected: string;
    tileName: string;
    onClick: () => void;
  }) {
    return (
      <div onClick={() => onClick()} style={{ cursor: "pointer" }}>
        <img
          src={icon}
          alt={tileName}
          style={{
            width: "90px",
            height: "90px",
            borderRadius: "4px",
            marginRight: "10px",
            border: tile === tileSelected ? "3px solid #0C2856" : "none",
          }}
        />
        <br />
        <p style={{ fontWeight: "500" }}>{tileName}</p>
      </div>
    );
  }

  return (
    <div>
      <p className="flex justify-between text-base font-bold pb-2.5">
        Mapa Base
      </p>
      <FormGroup row={true} sx={{ paddingBottom: "2rem", gap: "1rem" }}>
        {AVAILABLE_TILES.map((availableTile: Tiles) => (
          <MapTileImage
            key={availableTile}
            icon={getTilePreviewUrl(availableTile)}
            tileSelected={availableTile}
            tileName={TILE_CONFIG[availableTile].name}
            onClick={() => addNewTile(availableTile)}
          />
        ))}
      </FormGroup>
    </div>
  );
}
